<!-- Start -->
<div class="mt-block" :class="$style.rightPanel">
  <div v-if="spinner" :class="$style.pageMargin">
    <animation-processing fill="new-blue" :class="$style.pageSpinner"></animation-processing>
    <span class="mt-serif mt-serif--size3">
      {{$t('pages.contract.spinner.assigned_foundries')}}
    </span>
  </div>
  <div v-else>
    <!-- Foundry Email Verify Banner for grace period expired-->
    <FouEmailVerify
      :showCloseIcon="false"
      :onlyGracePeriodExpired="true"
      labelKey="components.general.verify_email.banner.grace_period_expired_label"
    />
    <VeeForm v-slot="{errors, handleSubmit, validateField}">
      <!-- //Start -->
      <div :class="[$style.container, ifImpersonate ?  $style.shiftFoundryHeader :'']">
        <div :class="$style.profileHeader">
          <div><a href="/foundry-profile"><span :class="$style.arrow" ></span></a></div>
          <div :class="$style.wrappercontainer">
            <MdTypography :class="$style.title" tag="p" variant="heading6--medium" responsive="false"> 
              {{ foundry.name }}
            </MdTypography>
            <MdTypography :class="$style.foundaryID" tag="p" color="spirits--700" variant="body2--regular" responsive="false">
              {{$t('pages.profile.foundaryID')}}{{ foundry.externalId }}
            </MdTypography>
          </div>
        </div>
        <div :class="$style.profileHeaderButtons">
          <div :class="$style.profileCompletionBar">
            <div :class="[foundryCompletenessPerc === 100 ? $style.hundredPercentCompletion : $style.actualProfileCompletion]"
            :style="{ width: foundryCompletenessPerc+'%'}"></div>
          </div>
          <div :class="$style.proflieCompletionPercentageTab">
            <span
              :class="$style.profileCompletionTxt">{{$t('pages.profile.new_foundry.profilecompletion.profilecompleteness')}}</span>
            <span :class="$style.profileCompletionPerc">{{foundryCompletenessPerc}}%</span>
          </div>
          <div :class="$style.profileHeaderButtonsInnerDiv">
            <MdButton data-qa-id="discard-foundry-btn" :class="$style.discardBtn" color="lightgrey" variant="none" @click="discardFoundry($event)">
              {{$t('pages.profile.discardbtn')}}
            </MdButton>
            <MdButton data-qa-id="save-foundry-btn" :class="$style.saveBtn"  :disabled="descriptionError || bannedWordForCity || !disabledBtn || Object.keys(errors).length" color="blue" variant="none"  @click="handleSubmit($event, saveFoundry)" >
              {{$t('pages.profile.savebtn')}}
            </MdButton>
          </div>
        </div>
      </div>
      <!-- //Image -->
      <div :class="$style.pageContainer">
        <div :class="$style.maincontent">
          <ImageUploader :getAvScanStatus="getAvScanStatus" :logoProcessing="imageProcessingLogo" :bannerProcessing="imageProcessingBanner" :name="foundry.name" :id="foundry.id" :imgBanner="imgBanner" :imgLogo="imgLogo" @update:imageUpload="imageUploadDetails" @delete:imageBanner="imageDelete"  @show:OverlayInfo="showOverlayInfoFunc"/>
        
          <div :class="$style.popUpContainer">
            <Modal v-if="isPopUp && closePopUpModal" @update:bundlepopup="closePopUp" @update:bundlepopupconfirm="deleteImage"
              showButtons="confirmandcancel" class="fou-modal">
              <template #title>
                <span id="modal-title" data-qa-id="modal-title" v-if="deleteOption === 'deleteBanner'">
                  Delete foundry banner?
                </span>
                <span id="modal-title" data-qa-id="modal-title" v-else>
                  Delete foundry logo?
                </span>
              </template>
              <template #content>
                <span id="modal-content" data-qa-id="modal-content">
                  {{$t('pages.profile.foundry_Img_delete_popup_msg')}}</span>
              </template>
            </Modal>
          </div>


          <!-- Foundry Information -->
          <section>
            <div>
              <div :class="$style.foundaryheading" id="FoundryInformation">
                <div :class="$style.foundryInfoHeading">
                  <MdTypography :class="$style.foundaryStart" tag="p" color="spirits--900" variant="heading7--medium" responsive="false">
                    {{$t('pages.profile.new_foundry.foundaryinfoheading')}}
                  </MdTypography>
                  <MdIconFailed :class="$style.imageHeadingInfo" color="spirits--500" rotate="down" size="md"  @click="showOverlayInfoFunc('foundryInformation')"/>
                </div>
                <div>
                  <MdTypography :class="$style.foundaryPara" tag="p" color="spirits--700" variant="body2--regular" responsive="false">
                    {{$t('pages.profile.new_foundry.founaryinfoPara')}}
                    <MdLink href='https://foundrysupport.monotype.com/hc/en-us/sections/360006088871-Your-Foundry' target="_blank" inline="true" underline="false" rel="noopener noreferrer">
                      {{$t('pages.profile.new_foundry.foundaryInfoParaLearnmore')}}
                    </MdLink>
                  </MdTypography>
                </div>
                <div :class="$style.foundryLocationDiv">
                  <div>
                    <MdTypography :class="$style.shortDiscreption" tag="p" color="spirits--800" variant="body1--medium"  responsive="false">
                      {{$t('pages.profile.new_foundry.foundrylocationHeading')}}
                    </MdTypography>
                  </div>
                  <div :class="$style.informationContainer">
                    <div :class="[showStates? $style.inputcontainer1 : $style.inputcontainercustom]">
                      <FouDropdown :options="country.options" :default-value="backendValue" :placeholder="customPlaceholder" :selectAction="handleSelectAction"
                      :customClass="$style.customDropdownClass" :customActiveClass="$style.customDropdownActiveClass"  rules="required|script_tag_validate" name="headOfficeCountry" :errorClass="$style.errorField"/>
                    </div>
        
                    <FouDropdown v-if="showStates" :options="states.options" :default-value="backendStateValue" :placeholder="'City/State of foundry'" :selectAction="handleStateSelectAction"
                    :customClass="$style.customDropdownClass" :customActiveClass="$style.customDropdownActiveClass" rules="required|script_tag_validate" name="headOfficeState" :errorClass="$style.errorField"
                   />
                  </div>
                </div>
              </div>
            </div>
            <!-- //Long description -->
            <div :class="$style.longDescription">
              <MdTypography :class="$style.longDescriptionHeading" tag="p" color="spirits--800" variant="body1--medium" responsive="false">
                {{$t('pages.profile.new_foundry.longdescheading')}}
              </MdTypography>
              <MdTypography :class="$style.longDescriptionPara" tag="p" color="spirits--700" variant="body2--regular" responsive="false">
                {{$t('pages.profile.new_foundry.longdecpara')}}
                <MdLink href='https://foundrysupport.monotype.com/hc/en-us/articles/360059414131-Writing-a-foundry-description' target='_blank' inline="true" underline="false" rel="noopener noreferrer">
                  {{$t('pages.profile.new_foundry.longdecLearnmore')}}
                </MdLink>
              </MdTypography>
              <div :class="$style.texteditor">
                <AiTextEditor
                  :id="$vId(this, 'foundry-description-new')"
                  :config="aiTextEditorConfig"
                  :foundryId="this.foundry.id"
                  :initialValue="foundry.foundryDescription[0].description"
                  :validateOnMount="!Boolean(this.foundry.externalId)"
                  @on-change="value => (foundry.foundryDescription[0].description = value)"
                  @on-blur-validation-done="handleErrorStatus"
                />
              </div>
            </div>
    
            <!-- // Diversity -->
            <div>
              <div :class="$style.diversityStart" id="Diversity">
                <div :class="$style.diversityheadingDiv">
                  <p :class="$style.diversityStartHeading">{{$t('pages.profile.new_foundry.dei_section.title')}}</p>
                  <InfoIcon :class="$style.imageHeadingInfo" fill="#C3CAD4" width="21" height="21" @click="showOverlayInfoFunc('dei')"/>
                </div>
                <span :class="$style.optionalLabel">{{$t('pages.profile.new_foundry.optional')}}</span>
              </div>
              <div :class="$style.diversityStartParaSection">
                <p :class="$style.diversityStartPara">{{$t('pages.profile.new_foundry.dei_section.sub_title')}}</p>
              </div>
              <div :class="$style.deiSelectionSection" id='deiSection'>
                <div :class="$style.questionRow" v-for="items in deiQuestionsArr" :key="items.id">
                  <h1>{{items.ques}}</h1>
                  <div :class="$style.checkboxWrapper">
                    <div :class="[$style.mT15, $style.checkboxDEIField]">
                      <input :class="[$style.checkboxIB]" type="checkbox" name="Yes"
                        @change="(e) => setDeiCheckbox(e, items.id)" :checked="items.selectedOption === 'Yes'" />
                      <span :class="[$style.ibCheckboxDesc, $style.fS14]">
                        {{ $t('pages.profile.new_foundry.dei_section.option1') }}
                      </span>
                    </div>
                    <div :class="[$style.mT15, $style.checkboxDEIField]">
                      <input :class="[$style.checkboxIB]" type="checkbox" name="No"
                        @change="(e) => setDeiCheckbox(e, items.id)" :checked="items.selectedOption === 'No'" />
                      <span :class="[$style.ibCheckboxDesc, $style.fS14]">
                        {{ $t('pages.profile.new_foundry.dei_section.option2') }}
                      </span>
                    </div>
                    <div :class="[$style.mT15, $style.checkboxDEIField]">
                      <input :class="[$style.checkboxIB]" type="checkbox" name="Prefer not to respond"
                        @change="(e) => setDeiCheckbox(e, items.id)"
                        :checked="items.selectedOption === 'Prefer not to respond'" />
                      <span :class="[$style.ibCheckboxDesc, $style.fS14]">
                        {{ $t('pages.profile.new_foundry.dei_section.option3') }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="isDeiError" class="mt-error" :class="$style.errorField" style="padding-left: 24px;">
                {{ $t('pages.profile.new_foundry.dei_section.error') }}
              </div>
            </div>
            <!-- Diversity End -->
          </section>
          
          <!-- // Primary information -->
          <div :class="$style.primaryinfo" id="PrimaryInfo">
            <div :class="$style.primaryinfoStart">
              <div :class="$style.headAndSvgWrapper">
                <MdTypography :class="$style.primaryinfoHeading" tag="p" color="spirits--900" variant="heading7--medium" responsive="false">
                  {{$t('pages.profile.new_foundry.primary_conatct_heading')}}
                </MdTypography>
                <MdIconFailed :class="$style.imageHeadingInfo" color="spirits--500" rotate="down" size="md"  @click="showOverlayInfoFunc('contactInformation')"/>
              </div>
              <MdTypography :class="$style.primaryinfoPara" tag="p" color="spirits--700" variant="body2--regular" responsive="false">
                {{$t('pages.profile.new_foundry.primary_contact_para')}}
              </MdTypography>
            </div>
            <div :class="[{[$style.errorFieldColor]: Object.hasOwn(errors, 'contact name')}, $style.primaryInfoInput]">
              <TextField :id="$vId(this, 'contact-name')" :errorClass="[$style.errorField]" class="mt-input" name="contact name"
                v-model="foundry.supportEmail.contactName"
                placeholder=""
                rules="foundryinfo_required:primary_contact" />
                <label :for="$vId(this, 'contact-name')">{{$t('pages.profile.new_foundry.primary_placeholder.contact_name')}}</label>
            </div>
            <div :class="[{[$style.errorFieldColor]: Object.hasOwn(errors, 'email address')}, $style.primaryInfoInput]">
              <TextField :id="$vId(this, 'email-address')" :errorClass="[$style.errorField]" name="email address"
                v-model="foundry.supportEmail.emailAddress" class="mt-input"
                placeholder=""
                rules="foundryinfo_required:email|validate_email" />
                <label :for="$vId(this, 'email-address')">{{$t('pages.profile.new_foundry.primary_placeholder.email')}}</label>
            </div>

            <div :class="[{[$style.errorFieldColor]: Object.hasOwn(errors, 'telephone')}, $style.primaryInfoInput]">
              <TextField :id="$vId(this, 'telephone')" :errorClass="[$style.errorField]" type="text" class="mt-input" name="telephone"
                    placeholder=""
                    v-model="foundry.address.telephone"
                    rules="script_tag_validate|numeric|max:20" @search:blur="validateField('telephone')"
                    />
                <label :class="$style.telephoneLargerScreen" :for="$vId(this, 'telephone')">{{$t('pages.profile.new_foundry.primary_placeholder.telephoneLargerScreen')}}</label>
                <label :class="$style.telephoneSmallScreen" :for="$vId(this, 'telephone')">{{$t('pages.profile.new_foundry.primary_placeholder.telephoneSmallScreen')}}</label>
                <span :class="$style.optional">{{$t('pages.profile.new_foundry.optional')}}</span>
            </div>

            <div :class="[{[$style.errorFieldColor]: Object.hasOwn(errors, 'website')}, $style.primaryInfoInput]">
              <TextField :id="$vId(this, 'website')" type="text" class="mt-input" name="website" :errorClass="[$style.errorField]"
                    placeholder=""
                    v-model="foundry.address.website" rules="script_tag_validate|validate_website_url"
                    @search:blur="validateField('website')"/>
                <label :for="$vId(this, 'website')">{{$t('pages.profile.new_foundry.primary_placeholder.website')}}</label>
                <span :class="$style.optional">{{$t('pages.profile.new_foundry.optional')}}</span>
            </div>

              <div :class="[{[$style.errorFieldColor]: Object.hasOwn(errors, 'address 1')}, $style.primaryInfoInput]">
                <TextField :id="$vId(this, 'address 1')" :errorClass="[$style.errorField]" type="text" name="address 1"
                v-model="foundry.address.address1"
                placeholder=""
                rules="foundryinfo_required:address1" />
                <label :for="$vId(this, 'address 1')">{{$t('pages.profile.new_foundry.primary_placeholder.address1')}}</label>
              </div>

              <div :class="[{[$style.errorFieldColor]: Object.hasOwn(errors, 'address 2')}, $style.primaryInfoInput]">
                <TextField :id="$vId(this, 'address-2')" type="text" class="mt-input" name="address 2"
                :errorClass="[$style.errorField]"
                v-model="foundry.address.address2"
                placeholder="" />
                <label :for="$vId(this, 'address 2')">{{$t('pages.profile.new_foundry.primary_placeholder.address2')}}</label>
                <span :class="$style.optional">{{$t('pages.profile.new_foundry.optional')}}</span>
              </div>
              <div :class="[$style.primarycustom, {[ $style.warningClass ]: (warningWordForCity && bannedWordForCity)}]">
                <div
                  :class="[{[$style.errorFieldColor]: Object.hasOwn(errors, 'city') || bannedWordForCity}, $style.primaryInfoInput, $style.countryvalue]">
                  <TextField :id="$vId(this, 'city')" type="text" class="mt-input" name="city" v-model="foundry.address.city"
                    placeholder="" rules="foundryinfo_required:city|script_tag_validate" :errorClass="[$style.errorField]" />
                  <label :for="$vId(this, 'city')">{{$t('pages.profile.new_foundry.primary_placeholder.city')}}</label>
                </div>
                <FouDropdown v-if="showAddressStates" :options="headOfficeStates.options" :default-value="backendAddressStateValue"
                  smallPlaceHolder="City/State" :placeholder="$t('components.navigation.sign_up.address.state_region')"
                  :selectAction="handleAddressStateSelectAction" :customClass="$style.customDropdownClass"
                  :customActiveClass="$style.customDropdownActiveClass" :class="$style.zIndex" rules="required|script_tag_validate"
                  name="state" :errorClass="$style.errorField" />
              </div>
            <div :class="$style.primarycustom">
              <div :class="[{[$style.errorFieldColor]: Object.hasOwn(errors, 'zipCode')}, $style.primaryInfoInput, $style.countryvalue]">
                <TextField :id="$vId(this, 'zipCode')" type="text" class="mt-input" name="zipCode"
                  v-model.trim="foundry.address.zipCode" 
                  @update-detect="(e)=> foundry.address.zipCode = foundry.address.zipCode.toUpperCase()"
                  placeholder=""
                    :rules="`foundryinfo_required:zipcode|max:10|postal_code_rule:${backendAddressCountryValue}`" :errorClass="[$style.errorField]" />
                  <label :for="$vId(this, 'zipCode')">{{$t('pages.profile.new_foundry.primary_placeholder.zipCode')}}</label>
              </div>
              <FouDropdown :options="country.options" :default-value="backendAddressCountryValue" :placeholder="'Country'" :selectAction="updateAddressCountryValue"
            :customClass="$style.customDropdownClass" :customActiveClass="$style.customDropdownActiveClass" rules="required|script_tag_validate" name="country" :errorClass="$style.errorField"
           />
            </div>
   
          </div>
          <!-- Email communication -->
          <div :class="$style.emailCommunication">
            <div :class="$style.flexContainer">
              <MdTypography :class="$style.emailCommunicationHeading" tag="p" color="spirits--900" variant="heading7--medium" responsive="false">
                {{$t('pages.profile.new_foundry.emailcommunication.emailheading')}}
              </MdTypography>
              <MdTypography :class="$style.optionalLabel" tag="span" color="spirits--700" variant="body2--regular" responsive="false">
                {{$t('pages.profile.new_foundry.optional')}}
              </MdTypography>
            </div>
            <MdTypography :class="$style.emailCommunicationPara" tag="p" color="spirits--700" variant="body2--regular" responsive="false">
              {{$t('pages.profile.new_foundry.emailcommunication.emailpara')}}
            </MdTypography>
            <div :class="$style.communicationPermission">
              <div>
                <input :class="[$style.communicationPermissioncheckbox]" id="emailCheck" type="checkbox" key="emailCheck" name="emailCheck"
                :value="foundry.emailConsent" @change="toggleEmailConsent($event)" :checked="emailConsentChecked"/>
              </div>
              <MdTypography :class="$style.communicationPermissionPara" tag="p" color="spirits--900" variant="body2--regular" responsive="false">
                {{$t('pages.profile.new_foundry.emailcommunication.emailconsenst')}}
              </MdTypography>
            </div>
          </div>  
        </div>
        <div :class="$style.profileContainer">
          <div :class="$style.profileCompletion">
            <div :class="$style.profileCompletionstatus">
              <MdTypography :class="$style.profileCompletionTxt" tag="span" color="spirits--600" variant="body2--medium">
                {{$t('pages.profile.new_foundry.profilecompletion.profilecompleteness')}}
              </MdTypography>
              <div :class=$style.foundryCompletionPercentageDiv>
                <MdTypography color="spirits--900" variant="heading5--bold">
                  {{foundryCompletenessPerc}}%
                </MdTypography>
                <div :class="$style.profileCompletionBar">
                  <div :class="[foundryCompletenessPerc === 100 ? $style.hundredPercentCompletion : $style.actualProfileCompletion]" :style="{ width: foundryCompletenessPerc+'%'}"></div>
                </div>
              </div>
            </div>
            <div :class="[$style.accordionDiv, ifImpersonate ? $style.shiftAccordion : '']" ref="accordionDivRef">
              <fou-accordion :class="$style.accordion" ref="accordionRef">
                <fou-accordion-item :id="$vId(this, 'imagery')" :class="$style.foundryProfileAccordianItem" ref="imageryAccordionItem" :open=true module="edit-profile">
                  <template #heading>
                    <div>
                      <a>
                        <MdTypography
                          tag="h2"
                          data-qa-id="foundryImagerySectionHeading"
                          :variant="getSectionVariant('FoundryImagery')"
                          :color="getSectionColor('FoundryImagery', foundryStatus.imagerySectionStatus)"
                          :class="getSectionClass('FoundryImagery', foundryStatus.imagerySectionStatus)"
                          @click="scrollToSection('FoundryImagery')"
                        >
                          {{$t('pages.profile.new_foundry.profilecompletion.foundryimagery.title')}}
                        </MdTypography>
                      </a>
  
                    </div>
                  </template>
  
                  <template #content>
                      <div :class="$style.steps">
                        <div :class="$style.steps1">
                          <div :class="$style.body" data-qa-id="foundry-profile-imagery-body">
                            <MdTypography data-qa-id="optionalText" variant="micro1--regular" color="spirits--700">
                              {{$t('pages.profile.new_foundry.optional')}}
                            </MdTypography>
                            <div :class="$style.text1">
                              <MdTypography data-qa-id="logoInfoText" tag="p" variant="body2--bold" color="spirits--700">
                                {{$t('pages.profile.new_foundry.profilecompletion.foundryimagery.logo')}}
                              </MdTypography>
                              <p :class="$style.resolutionMinimum256x256Pi">
                                <span>
                                  <MdTypography data-qa-id="resolutionText" tag="span" variant="micro1--regular" color="spirits--700">
                                    {{$t('pages.profile.new_foundry.profilecompletion.foundryimagery.resolution')}}
                                  </MdTypography>
                                  <MdTypography data-qa-id="resolutionValueText" tag="span" variant="micro1--medium" color="spirits--700">
                                    {{$t('pages.profile.new_foundry.profilecompletion.foundryimagery.resolution_value')}}
                                  </MdTypography>
                                </span>
                              </p>
                              <p :class="$style.resolutionMinimum256x256Pi">
                                <span>
                                  <MdTypography data-qa-id="sizeText" tag="span" variant="micro1--regular" color="spirits--700">
                                    {{$t('pages.profile.new_foundry.profilecompletion.foundryimagery.size')}}
                                  </MdTypography>
                                  <MdTypography data-qa-id="sizeValueText" tag="span" variant="micro1--medium" color="spirits--700">
                                    {{$t('pages.profile.new_foundry.profilecompletion.foundryimagery.size_logo')}}
                                  </MdTypography>
                                </span>
                              </p>
                              <p :class="$style.resolutionMinimum256x256Pi">
                                <span>
                                  <MdTypography data-qa-id="formatText" tag="span" variant="micro1--regular" color="spirits--700">
                                    {{$t('pages.profile.new_foundry.profilecompletion.foundryimagery.format')}}
                                  </MdTypography>
                                  <MdTypography data-qa-id="formatValueText" tag="span" variant="micro1--medium" color="spirits--700">
                                    {{$t('pages.profile.new_foundry.profilecompletion.foundryimagery.format_value')}}
                                  </MdTypography>
                                </span>
                              </p>
                              <p :class="$style.resolutionMinimum256x256Pi">
                                <span>
                                  <span>&nbsp;</span>
                                </span>
                              </p>
                              <MdTypography data-qa-id="BannerInfoText" tag="p" variant="body2--bold" color="spirits--700">
                                {{$t('pages.profile.new_foundry.profilecompletion.foundryimagery.banner')}}
                              </MdTypography>
                              <p :class="$style.resolutionMinimum256x256Pi">
                                <span>
                                  <MdTypography data-qa-id="resolutionBannerText" tag="span" variant="micro1--regular" color="spirits--700">
                                    {{$t('pages.profile.new_foundry.profilecompletion.foundryimagery.resolution')}}
                                  </MdTypography>
                                  <MdTypography data-qa-id="resolutionBannerValueText" tag="span" variant="micro1--medium" color="spirits--700">
                                    {{$t('pages.profile.new_foundry.profilecompletion.foundryimagery.resolution_banner_value')}}
                                  </MdTypography>
                                </span>
                              </p>
                              <p :class="$style.resolutionMinimum256x256Pi">
                                <span>
                                  <MdTypography data-qa-id="bannerSizeText" tag="span" variant="micro1--regular" color="spirits--700">
                                    {{$t('pages.profile.new_foundry.profilecompletion.foundryimagery.size')}}
                                  </MdTypography>
                                  <MdTypography data-qa-id="bannerSizeValueText" tag="span" variant="micro1--medium" color="spirits--700">
                                    {{$t('pages.profile.new_foundry.profilecompletion.foundryimagery.size_value')}}
                                  </MdTypography>
                                </span>
                              </p>
                              <p :class="$style.resolutionMinimum256x256Pi">
                                <span>
                                  <MdTypography data-qa-id="bannerFormatText" tag="span" variant="micro1--regular" color="spirits--700">
                                    {{$t('pages.profile.new_foundry.profilecompletion.foundryimagery.format')}}
                                  </MdTypography>
                                  <MdTypography data-qa-id="bannerFormatValueText" tag="span" variant="micro1--medium" color="spirits--700">
                                    {{$t('pages.profile.new_foundry.profilecompletion.foundryimagery.format_value')}}
                                  </MdTypography>
                                </span>
                              </p>
                              <p :class="$style.resolutionMinimum256x256Pi">
                                <span>
                                  <span>&nbsp;</span>
                                </span>
                              </p>
                              <p :class="$style.sizeMaximum8Mb">
                                  <MdTypography data-qa-id="imageDescText" tag="span" variant="micro1--regular" color="spirits--700">
                                    {{$t('pages.profile.new_foundry.profilecompletion.foundryimagery.image_desc')}}
                                  </MdTypography>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                  </template>
                </fou-accordion-item>
                <fou-accordion-item :id="$vId(this, 'information')" :class="$style.foundryProfileAccordianItem" ref="informationAccordionItem" module="edit-profile">
                  <template #heading>
                    <div>
                      <MdTypography
                        tag="h2"
                        data-qa-id="foundryInformationSectionHeading"
                        :variant="getSectionVariant('FoundryInformation')"
                        :color="getSectionColor('FoundryInformation', foundryStatus.InformationSectionStatus)"
                        :class="getSectionClass('FoundryInformation', foundryStatus.InformationSectionStatus)"
                        @click="scrollToSection('FoundryInformation')"
                      >
                        {{$t('pages.profile.new_foundry.profilecompletion.foundryinformation.title')}}
                      </MdTypography>
                    </div>
                  </template>
  
                  <template #content>
                    <div data-qa-id="foundry-profile-information-body">
                      <div :class="$style.foundryProfileAccordianItemDesc">
                        <MdTypography data-qa-id="info1Text" tag="p" variant="micro1--regular" color="spirits--700">
                          {{$t('pages.profile.new_foundry.profilecompletion.foundryinformation.info1')}}
                        </MdTypography><br />
                        <MdTypography data-qa-id="info2Text" tag="p" variant="micro1--regular" color="spirits--700">
                          {{$t('pages.profile.new_foundry.profilecompletion.foundryinformation.info2')}}
                        </MdTypography><br />
                        <MdTypography data-qa-id="info3Text" tag="p" variant="micro1--regular" color="spirits--700">
                          {{$t('pages.profile.new_foundry.profilecompletion.foundryinformation.info3')}}
                        </MdTypography><br />
                        <MdTypography data-qa-id="info4Text" tag="p" variant="micro1--regular" color="spirits--700">
                          {{$t('pages.profile.new_foundry.profilecompletion.foundryinformation.info4')}}
                        </MdTypography>
                      </div>
                      <MdTypography data-qa-id="learnMoreText" variant="body2--medium" :class="$style.externalLink" @click="clickedSectionToggle('FoundryInformation')">
                        <MdLink data-qa-id="learnMoreLink" href="https://foundrysupport.monotype.com/hc/en-us/articles/360059414131-Writing-a-foundry-description" target="_blank" rel="noopener noreferrer" color="darkgrey" underline="false">
                          {{$t('pages.profile.new_foundry.profilecompletion.foundryinformation.learnmore')}}
                        </MdLink>
                        <MdIconArrowLong data-qa-id="learnMoreIcon" :class="$style.externalLinkArrow" rotate="up-right" />
                      </MdTypography>
                    </div>
                  </template>
                </fou-accordion-item>
                <fou-accordion-item :id="$vId(this, 'Diversity')" :class="$style.foundryProfileAccordianItem" ref="diversityAccordionItem" module="edit-profile">
                  <template #heading>
                    <div>
                      <MdTypography
                        tag="h2"
                        data-qa-id="foundryDiversitySectionHeading"
                        :variant="getSectionVariant('Diversity')"
                        :color="getSectionColor('Diversity', foundryStatus.DiversitySectionStatus)"
                        :class="getSectionClass('Diversity', foundryStatus.DiversitySectionStatus)"
                        @click="scrollToSection('Diversity')"
                      >
                        {{$t('pages.profile.new_foundry.profilecompletion.dei.title')}}
                      </MdTypography>
                    </div>
                  </template>
  
                  <template #content>
                    <MdTypography data-qa-id="DiversityInfoText" tag="p" variant="micro1--regular" color="spirits--700">
                      {{$t('pages.profile.new_foundry.profilecompletion.dei.dei_info')}}
                    </MdTypography>
                  </template>
                </fou-accordion-item>
                <fou-accordion-item :id="$vId(this, 'contactinfo')" :class="$style.foundryProfileAccordianItem" ref="contactInfoAccordionItem" module="edit-profile">
                  <template #heading>
                    <div>
                      <MdTypography
                        tag="h2"
                        data-qa-id="foundryContactInfoSectionHeading"
                        :variant="getSectionVariant('PrimaryInfo')"
                        :color="getSectionColor('PrimaryInfo', foundryStatus.ContactInfoSectionStatus)"
                        :class="getSectionClass('PrimaryInfo', foundryStatus.ContactInfoSectionStatus)"
                        @click="scrollToSection('PrimaryInfo')"
                      >
                        {{$t('pages.profile.new_foundry.profilecompletion.primarycontactinfo.title')}}
                      </MdTypography>
                    </div>
                  </template>
  
                  <template #content>
                    <MdTypography data-qa-id="contactInfoText" tag="p" variant="micro1--regular" color="spirits--700">
                      {{$t('pages.profile.new_foundry.profilecompletion.primarycontactinfo.desc')}}
                    </MdTypography>
                  </template>
                </fou-accordion-item>
              </fou-accordion>
            </div>
          </div>
        </div>
      </div>
    </VeeForm>
  </div>
</div>

<div :class="$style.emailPopUp">
  <Modal v-if="emailConsentPopup" @update:bundlepopup="closeUnsubscribeModal" @update:popupunsubscribe="unsubscribeEmailConsent"
    showButtons="cancelandunsubscribe" class="fou-modal" :class="$style.emailModal">
    <template #title>
      <span id="modal-title" data-qa-id="modal-title" v-html="$sanitize($t('pages.profile.new_foundry.email_communication_popup.title'))"/>
    </template>
    <template #content>
      <span id="modal-content" data-qa-id="modal-content">
        {{$t('pages.profile.new_foundry.email_communication_popup.description')}}
      </span>
    </template>
  </Modal>
</div>

<OverlayInfo v-if="showOverlayInfo" :overlaySec="overlaySec" @close:OverlayInfo="closeOverlayInfo"/>

<well-done-foundry v-if="showWellDonePopup" @popup:crossBtnClick="closeWellDonePopUp" @popup:btn1Click="closeWellDonePopUp" 
@popup:btn2Click="isSomethingRemoved ? closeWellDonePopUp() : navigateToNextChallenge()"
:modalHeading="isSomethingRemoved ? $t('pages.profile.foundry_profile.well_done_popup.somethingRemovedTitle') : $t('pages.profile.foundry_profile.well_done_popup.title')" 
:modalContent="popupDescriptionText"
:modalButton2="getPopupButtonText()" 
:showButton1="false"
id="well-done-modal" data-qa-id="well-done-modal"/>

<well-done-foundry v-if="showGreatJobPopup" @popup:crossBtnClick="closeGreatJobPopUp" @popup:btn1Click="closeGreatJobPopUp" 
:modalHeading="$t('pages.profile.foundry_profile.great_job_popup.title')" 
:modalContent="$t('pages.profile.foundry_profile.great_job_popup.description')" 
:modalButton1="$t('pages.profile.foundry_profile.great_job_popup.btn1')" 
:showButton2="false"
:customBtn1Class="true"
id="great-job-modal" data-qa-id="great-job-modal" />

<common-popup v-if="showPermissionNeededPopup" @popup:crossBtnClick="closePermissionNeededPopup" @popup:btn1Click="closePermissionNeededPopup" 
:modalHeading="$t('pages.profile.foundry_profile.permission_denied.title')" 
:modalContent="$t('pages.profile.foundry_profile.permission_denied.description')" 
:modalButton1="$t('pages.profile.foundry_profile.permission_denied.btn1')" 
:showButton2="false"
:customBtn1Class="true"
id="permission-needed-modal" data-qa-id="permission-needed-modal" />